module.exports = __webpack_public_path__ + "img/tag-electronics.ee099f81.svg";